import { cva } from 'class-variance-authority'

export const tooltipStyles = cva(
  [
    'micro-interactions',
    'pointer-events-none',
    'absolute',
    'whitespace-nowrap',
    'rounded',
    'opacity-0',
    'transition',
    'before:absolute',
    'before:border-4',
    'before:border-transparent',
    "before:content-['']",
    'group-hover:opacity-100',
    'border',
    'shadow-lg',
    'py-1',
    'px-2',
    'border-border',
    'bg-popover',
    'text-popover-foreground',
    'z-(--ui-z-tooltips)',
    'text-sm',
  ],
  {
    variants: {
      position: {
        top: [
          'before:top-full',
          '-top-10',
          'left-1/2',
          'before:border-t-border',
          '-translate-x-1/2',
          'before:left-1/2',
          'before:-translate-x-1/2',
        ],
        bottom: [
          'top-full',
          'mt-2',
          '-translate-x-1/2',
          'left-1/2',
          'before:bottom-full',
          'before:left-1/2',
          'before:-translate-x-1/2',
          'before:border-b-border',
        ],
        left: [
          'right-full',
          'mr-2',
          '-translate-y-1/2',
          'top-1/2',
          'before:left-full',
          'before:top-1/2',
          'before:-translate-y-1/2',
          'before:border-l-border',
        ],
        right: [
          'ml-2',
          'top-1/2',
          'left-full',
          '-translate-y-1/2',
          'before:right-full',
          'before:top-1/2',
          'before:-translate-y-1/2',
          'before:border-r-border',
        ],
      },
    },
    defaultVariants: {
      position: 'top',
    },
  },
)
